<template>
  <div>
    <v-data-table
      :headers="headers"
      :items="DataTable"
      hide-default-footer
      class="elevation-1 fix-font"
      mobile-breakpoint="0"
      :loading="loading"
    >
      <template v-slot:top> </template>
      <template v-slot:item.actions="{ item }">
        <v-row class="pt-3">
          <v-btn
            @click="
              onDownloadProfileImage(
                item.imageProfile,
                item.firstNameTha + ' ' + item.lastNameTha
              )
            "
            color="yellow darken-3 white--text"
            small
            depressed
          >
            ดาวน์โหลดรูป
          </v-btn>
        </v-row>
        <v-row v-if="adminRole === 'SuperAdmin' && !item.retireStatus">
          <v-btn
            @click="onEditAdmin(item.reqCardCode)"
            :disabled="item.cardStatusId !== 3"
            color="warning"
            small
            depressed
          >
            ปลดการแก้ไข
          </v-btn>
        </v-row>
        <v-row v-if="!item.retireStatus">
          <v-btn
            @click="onSendEmail(item.reqCardCode)"
            color="primary"
            small
            depressed
            :disabled="item.cardStatusId !== 3"
          >
            ส่งอีเมล
          </v-btn>
        </v-row>
        <v-row class="pb-3">
          <v-btn
            @click="
              $linkPath(
                'HR',
                '/ReqCard/req/' + item.reqCardCode + '/admin',
                'none'
              )
            "
            color="info"
            small
            depressed
          >
            รายละเอียด
          </v-btn>
        </v-row>
      </template>
      <template v-slot:item.fullName="{ item }">
        <span class="text-body-1">{{
          item[`middleName${$lang}`]
            ? item[`prename${$lang}`] +
              ' ' +
              item[`firstName${$lang}`] +
              ' ' +
              item[`middleName${$lang}`] +
              ' ' +
              item[`lastName${$lang}`]
            : item[`prename${$lang}`] +
              ' ' +
              item[`firstName${$lang}`] +
              ' ' +
              item[`lastName${$lang}`]
        }}</span>
      </template>
      <template v-slot:item.sendEmail="{ item }">
        <span class="text-body-1">{{
          item.sendEmailNum > 0
            ? 'ส่งแล้ว(' + item.sendEmailNum + ')'
            : 'ยังไม่ได้ส่งอีเมล'
        }}</span>
      </template>
      <template v-slot:item.createDate="{ item }">
        <span class="text-body-1">
          {{ $dateFormatByLang(item.createDate) }}
        </span>
      </template>
      <template v-slot:item.cardStatusName="{ item }">
        <span class="text-body-1">
          {{ item.cardStatusName }}
        </span>
      </template>
      <template v-slot:item.cardTypeName="{ item }">
        <span class="text-body-1">
          {{ item.cardTypeName }}
        </span>
      </template>
      <template v-slot:footer>
        <div class="py-3">
          <v-pagination
            v-model="pageIndex"
            @input="initialInfo"
            :length="totalPage"
            :total-visible="7"
            style="justify-content: flex-end"
            circle
          />
        </div>
      </template>
    </v-data-table>
    <v-dialog v-model="edit.dialog" max-width="360" persistent>
      <v-card>
        <div class="pa-4 font-weight-bold">{{ edit.title }}</div>
        <v-divider />
        <div class="text-center py-4">
          <v-btn
            class="mx-1"
            color="primary darken-2"
            large
            depressed
            @click="apiSuperAdminEdit(edit.reqCardCode)"
          >
            ตกลง
          </v-btn>
          <v-btn
            class="mx-1"
            color="secondary"
            depressed
            @click="edit.dialog = false"
          >
            ยกเลิก
          </v-btn>
        </div>
      </v-card>
    </v-dialog>
    <v-dialog v-model="receipt.dialog" max-width="360" persistent>
      <v-card>
        <div class="pa-4 font-weight-bold">{{ receipt.title }}</div>
        <v-divider />
        <div class="text-center py-4">
          <v-btn
            class="mx-1"
            color="primary darken-2"
            large
            depressed
            @click="apiSendEmail(receipt.reqCardCode)"
          >
            ตกลง
          </v-btn>
          <v-btn
            class="mx-1"
            color="secondary"
            depressed
            @click="receipt.dialog = false"
          >
            ยกเลิก
          </v-btn>
        </div>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
export default {
  data: () => ({
    edit: {
      dialog: false,
      title: 'ต้องการปลดการแก้ไขหรือไม่',
      reqCardCode: ''
    },
    receipt: {
      dialog: false,
      title: 'ต้องการส่งอีเมลอีกครั้งหรือไม่',
      reqCardCode: ''
    },
    headers: [
      { text: 'วันที่ขอ', value: 'createDate' },
      { text: 'ผู้ขอ', value: 'fullName' },
      { text: 'สถานะคำขอ', value: 'cardStatusName' },
      { text: 'ประเภทบัตร', value: 'cardTypeName' },
      { text: 'การส่งอีเมล', value: 'sendEmail' },
      { text: 'จัดการ', value: 'actions', sortable: false }
    ],
    pageIndex: 1,
    totalPage: 1,
    DataTable: [],
    loading: false
  }),
  mounted() {
    this.initialInfo()
  },
  watch: {
    '$root.$i18n.locale'() {
      this.initialInfo()
    },
    $route() {
      this.pageIndex = 1
      this.initialInfo()
    }
  },
  computed: {
    adminRole() {
      return this.adminStatusObj.accessRoleName
    },
    formData() {
      const query = this.$route.query
      let body = {
        SearchAllStatus: false,
        FirstName: query.firstName || '',
        LastName: query.lastName || '',
        ReqCardCode: query.cardId || '',
        StartDate: query.cardStartDate || '',
        EndDate: query.cardEndDate || '',
        CardStatusId: query.cardStatus || '2',
        CardTypeID: query.cardType || '0',
        StartIndex: this.pageIndex.toString(),
        LimitNumber: '10'
      }
      return body
    }
  },
  methods: {
    onEditAdmin(cardcode) {
      this.edit.dialog = true
      this.edit.reqCardCode = cardcode
    },
    onSendEmail(cardcode) {
      this.receipt.dialog = true
      this.receipt.reqCardCode = cardcode
    },
    onDownloadProfileImage(profileImg, filename) {
      // console.log(this.profileImg)
      var arr = profileImg.split(',')
      var mime = arr[0].match(/:(.*?);/)[1]
      var type = mime.split('/')[1]

      var fileLink = document.createElement('a')
      fileLink.href = profileImg
      fileLink.download = filename + '.' + type
      // document.body.appendChild(fileLink)
      fileLink.click()
    },
    async apiSuperAdminEdit(cardCode) {
      try {
        const res = await this.$store.dispatch('reqCard/superAdminSetEdit', {
          ReqCardCode: cardCode
        })
        this.edit.dialog = false
        this.initialInfo()
        return res.data?.data
      } catch (e) {
        console.log(e.response || e)
      }
    },
    async initialInfo() {
      const info = await this.apiAdminSearch(this.formData)
      this.totalPage = Math.ceil(info.pageManageObj.valueSearchCount / 10)
      this.DataTable = info.userReqDetail
      this.adminStatusObj = info.adminStatusObj
      this.$emit('search', info.pageManageObj.valueSearchCount)
      this.$emit('type', info)
    },
    async apiAdminSearch(payload) {
      this.loading = true
      try {
        const res = await this.$store.dispatch('reqCard/adminSearch', payload)
        this.loading = false
        return res.data.data[0]
      } catch (e) {
        this.loading = false
        console.log(e.response || e)
      }
    },
    async apiSendEmail(cardCode) {
      try {
        const res = await this.$store.dispatch('reqCard/sendEmail', {
          ReqCardCode: cardCode
        })
        this.receipt.dialog = false
        this.initialInfo()
        return res.data?.data
      } catch (e) {
        console.log(e.response || e)
      }
    }
  }
}
</script>

<style scoped>
.fix-font {
  white-space: nowrap;
}
</style>
